import ODataUtil from "./ODataUtil";
import { deleteItem, patchItem, postItem, ApiRequest } from './ApiUtils';
import WeatherImpact from 'classes/WeatherImpact';
import buildQuery from 'odata-query';

const weatherImpactEndpoint = "/WeatherImpact";

/**
 * Get weather impacts with OData query support
 */
async function getWeatherImpacts(page, per_page, orderByInfo, orderByDirection, search, filters) {
  try {
    const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
      per_page, page, WeatherImpact.expand, orderByInfo, orderByDirection, filters
    );
    const filter = {};
    const isDefaults = filters.find(r => r.defaults);

    if (isDefaults) {
      const defaults = isDefaults.defaults;
      if(defaults.projectId) filter["ihwi/workItem/projectId"] = { eq: { type: 'guid', value: defaults.projectId }};
      if(defaults.inspectionNumber) filter["ihwi/inspection/inspectionNumber"] = defaults.inspectionNumber;
    }

    const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
    const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });

    const data = await ApiRequest(weatherImpactEndpoint, params);
    return WeatherImpact.convertToTableRows(data);
  } catch (error) {
    console.error('Error fetching weather impacts:', error);
    throw error;
  }
}

/**
 * Add a new weather impact
 */
async function addWeatherImpact(data) {
  try {
    const resourcePath = `${weatherImpactEndpoint}/Add`;
    const result = await postItem(resourcePath, '', data);
    return result;
  } catch (error) {
    console.error('Error adding weather impact:', error);
    throw error;
  }
}

/**
 * Update an existing weather impact
 */
async function updateWeatherImpact(weatherImpactsId, data) {
  try {
    const resourcePath = `${weatherImpactEndpoint}/Update`;
    const params = `?weatherImpactsId=${weatherImpactsId}`;
    const result = await patchItem(resourcePath, params, data);
    return result;
  } catch (error) {
    console.error('Error updating weather impact:', error);
    throw error;
  }
}

/**
 * Delete a weather impact
 */
async function deleteWeatherImpact(weatherImpactsId) {
  try {
    const resourcePath = `${weatherImpactEndpoint}/Delete`;
    const params = `?weatherImpactsId=${weatherImpactsId}`;
    const result = await deleteItem(resourcePath, params);
    return result;
  } catch (error) {
    console.error('Error deleting weather impact:', error);
    throw error;
  }
}

/**
 * Get a specific weather impact by ID
 */
async function getWeatherImpactById(weatherImpactsId) {
  try {
    const expand = WeatherImpact.expand;
    const { expand: expandQuery } = ODataUtil.UtilityBuilderNestedv3(
      1,
      0,
      expand,
      null,
      null,
      []
    );

    const params = buildQuery({
      expand: expandQuery,
      filter: { WeatherImpactsId: { eq: { type: 'guid', value: weatherImpactsId } } }
    });

    const response = await fetch(`${weatherImpactEndpoint}${params}`);
    const result = await response.json();

    if (result.value && result.value.length > 0) {
      return new WeatherImpact(result.value[0]);
    }

    return null;
  } catch (error) {
    console.error('Error fetching weather impact by ID:', error);
    throw error;
  }
}

export {
  getWeatherImpacts,
  addWeatherImpact,
  updateWeatherImpact,
  deleteWeatherImpact,
  getWeatherImpactById
};
